;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.pennylane.inbox')
    .controller('PennylaneInboxToolbarController', PennylaneInboxToolbarController)

  PennylaneInboxToolbarController.$inject = [
    // Angular
    '$state',
    // Libs
    // Managers
    // Services
    'PennylaneService',
    'SnackService'
    // Const
    // Resolved
  ]

  /**
   * Toolbar de l'inbox Pennylane : bouton « Synchroniser » — déclenche la
   * réception synchrone côté backend (`POST /invoices/reception/sync`,
   * réponse `{ imported, failed, invoiceIds }`) puis recharge le state
   * (la vue liste est un sibling : `$state.reload()` relance ses resolves
   * et son controller, donc la liste).
   *
   * Affiche aussi la date de dernière synchronisation
   * (`pennylane.receptionLastRunAt` sur la company : posée à la fin de CHAQUE
   * run de sync, même avec échecs partiels, horloge backend — PAS le watermark
   * `receptionLastSyncedAt`, horloge Pennylane, qui peut être plus vieux que
   * le run réel). Lecture FRAÎCHE via `getFreshCompany` — jamais la version
   * mémoïsée ; le `$state.reload()` post-sync ré-instancie ce controller → la
   * date se rafraîchit seule.
   */
  function PennylaneInboxToolbarController (
    // Angular
    $state,
    // Libs
    // Managers
    // Services
    PennylaneService,
    SnackService
    // Const
    // Resolved
  ) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        /** Verrou anti double-clic pendant la synchronisation. */
        syncing: false,
        /** Company lue avec succès → le libellé de dernière synchro s'affiche. */
        companyLoaded: false,
        /** Date ISO du dernier RUN de synchro réception (null = jamais). */
        lastSyncedAt: null,
        // Public Methods
        sync
      })

      loadLastSyncedAt()
    }

    /**
     * Lit `pennylane.receptionLastRunAt` sur la company (lecture FRAÎCHE, non
     * mémoïsée : la date bouge à chaque run de sync). Champ absent/null (dont
     * backend pas encore redéployé avec ce champ) → « Jamais synchronisée » ;
     * échec de lecture / aucune company → rien d'affiché (getFreshCompany ne
     * rejette jamais, aucun toast global).
     */
    function loadLastSyncedAt () {
      PennylaneService.getFreshCompany().then((company) => {
        if (!company) {
          return
        }
        self.companyLoaded = true
        self.lastSyncedAt = (company.pennylane && company.pennylane.receptionLastRunAt) || null
      })
    }

    /** Synchronise les factures reçues depuis Pennylane puis recharge la liste. */
    function sync () {
      if (self.syncing) {
        return
      }
      self.syncing = true
      PennylaneService.syncReception()
        .then((res) => {
          const summary = (res && res.data) || {}
          const imported = summary.imported || 0
          let text = 'Synchronisation Pennylane terminée : ' + imported + ' facture(s) importée(s).'
          if (summary.failed) {
            text += ' ' + summary.failed + ' en échec.'
          }
          SnackService.snack({ text: text, delay: 5000 })
          // Recharge complète du state → la liste affiche les nouvelles factures.
          // (Le controller est détruit par le reload : pas besoin de lever le
          // verrou — sauf si le reload échoue, d'où le catch.)
          $state.reload().catch(() => {
            self.syncing = false
          })
        })
        .catch((err) => {
          // 404 (aucune company) / 409 (non connectée) : toast global supprimé
          // par ignoreErrors côté service → message fonctionnel dédié. Les
          // autres erreurs gardent le toast global, on lève juste le verrou.
          if (err && (err.status === 404 || err.status === 409)) {
            SnackService.snack({
              text: 'Entreprise non connectée à Pennylane — configurez la connexion dans les préférences.',
              delay: 5000
            })
          }
          self.syncing = false
        })
    }
  }
})(window.angular, window._)
